// src/components/InfoCard.tsx
import React from "react";
import "./InfoCard.css";

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  desc: string;
  bgColor?: string; // Optional, default to purple
}

const DEFAULT_BG = "#7c3aed7e !important";

const InfoCard: React.FC<InfoCardProps> = ({ icon, title, desc, bgColor }) => (
  <div
    className="info-card"
    style={{ background: bgColor || DEFAULT_BG, color: "#fff" }}
  >
    {/* Icon as a faded background */}
    <span className="info-card-bgicon">{icon}</span>
    <b className="info-card-title">{title}</b>
    <div className="info-card-desc">{desc}</div>
  </div>
);

export default InfoCard;
